import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\User\\Documents\\Git\\gomezth\\node_modules\\@mui\\material\\Box\\Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\User\\Documents\\Git\\gomezth\\node_modules\\@mui\\material\\Typography\\Typography.mjs");
;
import(/* webpackMode: "eager" */ "D:\\User\\Documents\\Git\\gomezth\\src\\components\\Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default","BORDER_CREAM","BORDER_NAVY"] */ "D:\\User\\Documents\\Git\\gomezth\\src\\components\\DividedGrid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\User\\Documents\\Git\\gomezth\\src\\components\\FAQAccordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\User\\Documents\\Git\\gomezth\\src\\components\\MoreLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\User\\Documents\\Git\\gomezth\\src\\components\\PersonCard.js");
;
import(/* webpackMode: "eager" */ "D:\\User\\Documents\\Git\\gomezth\\src\\theme\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\User\\Documents\\Git\\gomezth\\src\\views\\servicios\\ServiciosSegments.js");
